export default __webpack_public_path__ + "static/media/merienda.3123ac41.png";